import React from "react";

export default class extends React.Component {
  render() {
    const classes = ["fa fa-spinner fa-spin", this.props.classes].join(" ");

    return <i className={classes} />;
  }
}
